// import { TokenService } from '@/services/storage.service'
import Student from '@/modules/student/models/Student'

export default {
  namespaced: true,
  actions: {
    async register({ dispatch }, { payload }) {
      try {
        const student = await this._vm.$axios.post(
          '/api/students/signup',
          payload
        )
        dispatch('entities/students/insert', { data: student }, { root: true })
        return student
      } catch (error) {
        throw error
      }
    },
    async login({ _dispatch }, { payload }) {
      try {
        const accessToken = await this._vm.$axios.post(
          '/api/students/oauth/token',
          {
            username: payload.username,
            password: payload.password
          }
        )
        return accessToken
      } catch (error) {
        throw error
      }
    },
    async forgotPassword({ _dispatch }, { payload }) {
      try {
        await this._vm.$axios.post('/api/students/forgot-password', payload)

        return true
      } catch (error) {
        throw error
      }
    },
    async resetPassword({ _dispatch }, { payload }) {
      try {
        await this._vm.$axios.post('/api/students/reset-password', payload)

        return true
      } catch (error) {
        throw error
      }
    },
    async startClassLesson({ _dispatch }, { payload }) {
      try {
        const studentLesson = await this._vm.$axios.post(
          `/api/students/custom-classes/${payload.customClassId}/lessons/${payload.slug}`
        )
        return studentLesson
      } catch (error) {
        throw error
      }
    },
    async fetchUserLessons({ _dispatch }, { payload }) {
      const studentLessons = await this._vm.$axios.get(
        `/api/students/custom-classes/${payload.customClassId}/lessons`
      )

      return studentLessons
    },
    async fetchStudentForTeacher({ _dispatch }, studentId) {
      const student = await this._vm.$axios.get(
        `/api/teachers/students/${studentId}`
      )

      Student.insert({ data: student }, { root: true })

      return student
    },

    /**
     *  Get todo list
     */
    async todoList({ _dispatch }) {
      const todoList = await this._vm.$axios.get('/api/students/todos')

      return todoList
    },

    async resetUsername({ _dispatch }, { payload }) {
      try {
        const student = await this._vm.$axios.post(
          '/api/students/forgot-username',
          payload
        )

        return student
      } catch (error) {
        throw error
      }
    }
  }
}
